module.exports = __webpack_public_path__ + "img/service2.625b1c7f.webp";